module.exports = __webpack_public_path__ + "img/stake.7d14f6f7.svg";